<template>
  <section class="inside-content">
    <header class="inside-content__header">
      <h1 class="inside-content__title">
        <span v-if="icon" v-dompurify-html="icon" />
        {{ title }}
        <Hint v-if="hint" :message="hint" />
      </h1>

      <div class="inside-content__actions">
        <slot name="actions" />
      </div>
    </header>

    <p
      v-if="description"
      v-dompurify-html="description"
      class="inside-content__description"
    />
    <slot />
  </section>
</template>

<script>
import Hint from '@@/common/Hint';

export default {
  name: 'InsideContent',
  components: {
    Hint,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.inside-content {
  &__header {
    display: flex;
    align-items: center;
    margin-bottom: $global-margin;
  }

  &__title {
    position: relative;
    margin: 0;
    flex-grow: 1;
    /* Typography */
    color: $wet-asphalt;
    font-size: rem-calc(24);
    font-weight: 300;
  }

  &__actions {
    display: flex;
    align-items: center;
  }

  &__actions > * {
    margin-left: $global-margin;

    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin;
    }
  }

  &__description {
    /* Box Model */
    margin-top: $global-margin * $lb-small-size-factor;
    margin-bottom: $global-margin * $lb-small-size-factor;

    /* Typography */
    color: rgba(0, 0, 0, 0.4);

    @include breakpoint(large) {
      margin-top: $global-margin;
      margin-bottom: $global-margin * 2;
    }
  }
}
</style>
